/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevTerminalIcon20Light = forwardRef('DevTerminalIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5.146 7.396a.5.5 0 0 1 .708 0L7.75 9.293a1 1 0 0 1 0 1.414l-1.896 1.897a.5.5 0 0 1-.708-.708L7.043 10 5.146 8.104a.5.5 0 0 1 0-.708Z" }),
        React.createElement("path", { d: "M9.5 12a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 6a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6Zm3-2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H5Z" })));
});
